import { render, staticRenderFns } from "./publicity.vue?vue&type=template&id=d37d5484&scoped=true&"
import script from "./publicity.vue?vue&type=script&lang=js&"
export * from "./publicity.vue?vue&type=script&lang=js&"
import style0 from "./publicity.vue?vue&type=style&index=0&id=d37d5484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37d5484",
  null
  
)

export default component.exports